__webpack_require__.p = "/reports-scrolling-on-types-select/onboarding/";